import IUseCase from '~/@core/application/IUseCase';
import DefaultPaginated from '~/@core/domain/@shared/DefaultPaginated';
import FilterData from '~/@core/domain/filters/rfidReports/FilterData';
import Done from '~/@core/domain/model/rfidReports/Done';
import { InventoryService } from '~/@core/infrastructure/api/services/rfidReports';

export default class GetDones
  implements IUseCase<FilterData, Promise<DefaultPaginated<Done[]>>>
{
  execute(filter: FilterData): Promise<DefaultPaginated<Done[]>> {
    return InventoryService.fetchDones(filter);
  }
}
